export default {
  items: (state) => state.items,
  itemsMeta: (state) => state.itemsMeta,
  itemsLoading: (state) => state.itemsLoading,
};
